import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import BalanceToolbar from '../../components/BalanceToolbar';
import { InterestBalanceList } from './InterestBalanceList';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const InterestBalanceListView = ({ config }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t(config.titleKey)}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <BalanceToolbar config={config} />
          <Box mt={3}>
            <InterestBalanceList config={config} />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

InterestBalanceListView.propTypes = {
  config: PropTypes.object.isRequired
};

export default InterestBalanceListView;
